import { render, staticRenderFns } from "./NoReply.vue?vue&type=template&id=6b6b1eb4&scoped=true&"
import script from "./NoReply.vue?vue&type=script&lang=js&"
export * from "./NoReply.vue?vue&type=script&lang=js&"
import style0 from "./NoReply.vue?vue&type=style&index=0&id=6b6b1eb4&prod&scoped=true&lang=scss&"
import style1 from "./NoReply.vue?vue&type=style&index=1&id=6b6b1eb4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b6b1eb4",
  null
  
)

export default component.exports